import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  PayableDocument,
  CreatePayableDto,
  UpdatePayableDto,
  PayableFilter,
  PagedResult
} from '../models/payable.model';

@Injectable({ providedIn: 'root' })
export class PayablesService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Payables`;

  getFiltered(filter: PayableFilter): Observable<PagedResult<PayableDocument>> {
    let params = new HttpParams();

    if (filter.supplierId) {
      params = params.set('supplierId', filter.supplierId);
    }
    if (filter.status !== undefined) {
      params = params.set('status', filter.status.toString());
    }
    if (filter.overdueOnly !== undefined) {
      params = params.set('overdueOnly', filter.overdueOnly.toString());
    }
    if (filter.invoiceDateFrom) {
      params = params.set('invoiceDateFrom', filter.invoiceDateFrom);
    }
    if (filter.invoiceDateTo) {
      params = params.set('invoiceDateTo', filter.invoiceDateTo);
    }
    if (filter.dueDateFrom) {
      params = params.set('dueDateFrom', filter.dueDateFrom);
    }
    if (filter.dueDateTo) {
      params = params.set('dueDateTo', filter.dueDateTo);
    }
    if (filter.searchText) {
      params = params.set('searchText', filter.searchText);
    }
    if (filter.page) {
      params = params.set('page', filter.page.toString());
    }
    if (filter.pageSize) {
      params = params.set('pageSize', filter.pageSize.toString());
    }

    return this.http.get<PagedResult<PayableDocument>>(this.base, { params }).pipe(catchError(this.handle));
  }

  getBySupplier(supplierId: string): Observable<PayableDocument[]> {
    return this.http.get<PayableDocument[]>(`${this.base}/by-supplier/${supplierId}`).pipe(catchError(this.handle));
  }

  getById(id: string): Observable<PayableDocument> {
    return this.http.get<PayableDocument>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  create(dto: CreatePayableDto): Observable<PayableDocument> {
    return this.http.post<PayableDocument>(this.base, dto).pipe(catchError(this.handle));
  }

  update(id: string, dto: UpdatePayableDto): Observable<PayableDocument> {
    return this.http.put<PayableDocument>(`${this.base}/${id}`, dto).pipe(catchError(this.handle));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
